// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { scrubSingleModulationScheme } from '../'

const scrubAllModulationSchemes = m => (
  m.reduce((a, d, i) => {
    a.push(scrubSingleModulationScheme(d))
    return a
  }, [])
)

export default scrubAllModulationSchemes
